//足球 联赛 CSL|中超 full
import PlatfromFootballLeagueFullCSL from '@containers/platfrom_football/footballLeagueFull_CSL.vue'

export default {
  PlatfromFootballLeagueFullCSL,
}
